module.exports = __webpack_public_path__ + "static/img/process-pic-1.45b09fa4.png";